/* eslint no-shadow: 0 */

import actions from './actions';
import mutations from './mutations';

const initialState = {
  initialized: false,
  banners: {},
};

const state = Object.assign({}, initialState);

const getters = {
  isInitialized: state => state.initialized,
  banners: state => state.banners,
};

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default module;
export { initialState };
